import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { PromptLibraryIcon } from '../../promptsLibrary/PromptLibraryIcon';

export const CardIcon = ({ icon }: { icon?: string }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        svg: {
          width: '24px',
          height: '24px',
          '& path': {
            stroke: colors.grey[500],
          },
          '& circle': {
            stroke: colors.grey[500],
          },
        },
      }}
    >
      <PromptLibraryIcon icon={icon} />
    </Stack>
  );
};
